
import { useState, useEffect, useCallback } from 'react';
import { useDataEngine } from '@dhis2/app-runtime';
import {
  APPRAISAL_PROGRAM,
  DATA_ELEMENTS,
  APPRAISAL_STATUSES,
} from '../api/appraisalConstants';

const mapDataValuesToAppraisal = (dataValues = []) => {
  const map = {};
  dataValues.forEach((dv) => {
    if (dv.dataElement === DATA_ELEMENTS.APPRAISAL_STATUS) {
      map.appraisalStatus = dv.value;
    } else if (dv.dataElement === DATA_ELEMENTS.EMPLOYEE_SELF_RATING_TASK) {
      map.employeeSelfRatingTask = dv.value;
    } else if (dv.dataElement === DATA_ELEMENTS.EMPLOYEE_SELF_RATING_BEHAVIOURAL) {
      map.employeeSelfRatingBehavioural = dv.value;
    } else if (dv.dataElement === DATA_ELEMENTS.EMPLOYEE_COMMENTS) {
      map.employeeSelfComments = dv.value;
    } else if (dv.dataElement === DATA_ELEMENTS.MANAGER_RATING_TASK) {
      map.managerRatingTask = dv.value;
    } else if (dv.dataElement === DATA_ELEMENTS.MANAGER_RATING_BEHAVIOURAL) {
      map.managerRatingBehavioural = dv.value;
    } else if (dv.dataElement === DATA_ELEMENTS.MANAGER_COMMENTS) {
      map.managerComments = dv.value;
    }
  });

  map.appraisalStatus = map.appraisalStatus || APPRAISAL_STATUSES.DRAFT;
  return map;
};

// ✅ Accept programStage as parameter
export const useAppraisalEvents = (positionTEI, programStage, orgUnit, engine) => {
  const [appraisalEvent, setAppraisalEvent] = useState(null);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!positionTEI || !programStage || !orgUnit || !engine) {
      setAppraisalEvent(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      setLoading(true);
      const response = await engine.query({
        appraisal: {
          resource: 'events',
          params: {
            program: 'yiT00XKrrHP',
            programStage: programStage,
            trackedEntityInstance: positionTEI, 
            orgUnit: orgUnit,        // ✅ Critical!
            ouMode: 'ACCESSIBLE',    // ✅ Ensures cross-org access if granted
            fields: 'event,dataValues[dataElement,value]',
            pageSize: 1,
          }
        },
      });

       const event = response.appraisal?.events?.[0] || null;
      if (event) {
        const mappedData = mapDataValuesToAppraisal(event.dataValues);
        setAppraisalEvent({
          eventId: event.event,
          ...mappedData,
        });
      } else {
        // Initialize blank appraisal
        setAppraisalEvent({
          eventId: null,
          appraisalStatus: APPRAISAL_STATUSES.DRAFT,
          employeeSelfRatingTask: '',
          employeeSelfRatingBehavioural: '',
          employeeSelfComments: '',
          managerRatingTask: '',
          managerRatingBehavioural: '',
          managerComments: '',
        });
      }
    } catch (error) {
      console.error('Error loading appraisal event:', error);
      setAppraisalEvent(null);
    } finally {
      setLoading(false);
    }
  }, [positionTEI, programStage, orgUnit, engine]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { appraisalEvent, loading, refetch };
};